// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1C7tv","inner":"Footer_inner__3ppzI"};